import { render, staticRenderFns } from "./chainPage.vue?vue&type=template&id=9d623d18&scoped=true"
import script from "./chainPage.vue?vue&type=script&lang=js"
export * from "./chainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d623d18",
  null
  
)

export default component.exports